import React from "react";
import Nav from "../components/Nav";
import LoggedNav from "../components/LoggedNav";
import AddAddressDetails from "../components/AddAddressDetails";

function AddCard(props) {
  return (
    <>
      {localStorage.getItem("token") ? <LoggedNav customer={props.customer} /> : <Nav customer={props.customer} />}
      <AddAddressDetails image={props.image} customer={props.customer} />
    </>
  );
}

export default AddCard;
